import script from "./loading-placeholder.vue?vue&type=script&setup=true&lang=js"
export * from "./loading-placeholder.vue?vue&type=script&setup=true&lang=js"

import "./loading-placeholder.vue?vue&type=style&index=0&id=863bdd7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-863bdd7a"]])

export default __exports__